import * as apiGetUser from "@/api/vp/users/getUser";
import * as apiGetUsersWithRoleForVenue from "@/api/vp/venues/getUsersWithRoleForVenue";
import * as apiGetUsersWithRole from "@/api/vp/venues/getUsersWithRole";
import * as apiGetAddress from "@/api/vp/venues/getAddress";
import * as apiUpdateAddress from "@/api/vp/venues/updateAddress";
import * as apiGetGeneralInfo from "@/api/vp/venues/getGeneralInfo";
import * as apiUpdateOpeningHours from "@/api/vp/venues/updateOpeningHours";
import * as apiUpdateGeneralInfo from "@/api/vp/venues/updateGeneralInfo";
import * as apiGetOpeningHours from "@/api/vp/venues/getOpeningHours";
import * as apiGetUserVenues from "@/api/vp/venues/getUserVenues";
import * as apiGetMaintenanceReviews from "@/api/vp/venues/getMaintenanceReviews";
import * as apiGetVisits from "@/api/vp/venues/getVisits";
import * as apiGetVisitDetails from "@/api/vp/venues/getVisitDetails";
import * as apiDeleteVisit from "@/api/vp/venues/deleteVisit";
import _ from "lodash";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    loading: false,
    allLoading: false,
    loadedAllVisits: false,
    loadedAllReviews: false,
    userVenues: [],
    activeVenue: null,
    visits: {},
    maintenanceReviews: {},
    visitDetails: {},
    generalInfo: null,
    openingHours: null,
    openingHoursForSpecificVenue: null,
    address: null,

    contactUsers: [],
    contactRoles: ["vm", "svm", "avm", "rm", "rd"],
    contactRolesMap: ["Venue Manager", "Snr. Venue Manager", "Ass. Venue Manager", "Regional Manager", "Regional Director"],

    guestRelationUsers: [],
  },
  mutations: {
    gotOpeningHours(state, payload) {
      console.log("Opening hours", payload);
      state.openingHours = payload;
    },
    gotAddress(state, payload) {
      state.address = payload;
    },
    gotGeneralInfo(state, payload) {
      state.generalInfo = payload;
    },
    gotUserVenues(state, venues) {
      state.userVenues = venues;

      if (!localStorage.activeVenue && venues.length > 0) {
        localStorage.activeVenue = venues[0].venueId;
      }
    },
    gotVisits(state, payload) {
      Vue.set(
        state.visits,
        payload.venueId,
        _.sortBy(payload.result, v => v.completedOn).reverse()
      );
    },
    gotMaintenanceReviews(state, payload) {
      Vue.set(
        state.maintenanceReviews,
        payload.venueId,
        _.sortBy(payload.result, v => v.completedOn).reverse()
      );
    },
    gotVisitDetails(state, payload) {
      Vue.set(state.visitDetails, payload.surveySessionId, payload.result);
    },
    isLoading(state, loading) {
      state.loading = loading;
    },
    allLoading(state, allLoading) {
      state.allLoading = allLoading;
    },

    loadedAllVisits(state, status) {
      state.loadedAllVisits = status;
    },
    loadedAllReviews(state, status) {
      state.loadedAllReviews = status;
    },
    gotContactUsers(state, contactUsers) {
      state.contactUsers = contactUsers;
    },
    gotGuestRelationUsers(state, guestRelationUsers) {
      console.log("Guest relation users", guestRelationUsers);
      state.guestRelationUsers = guestRelationUsers;
    }
  },
  actions: {
    async getContactUsers({ commit, getters, state }) {
      const contactUsers = [];
      for (const idx in state.contactRoles) {
        const role = state.contactRoles[idx];
        const result = await apiGetUsersWithRoleForVenue.get(role, getters.activeVenue.venueId);
        for (const userIdx in result) {
          const user = await apiGetUser.get(result[userIdx]);
          contactUsers.push({ "userRole": role, ...user });
        }
      }
      commit("gotContactUsers", contactUsers);
    },
    async getGuestRelationUsers({ commit, getters, state }) {
      const role = "gr"
      const guestRelationUsers = await apiGetUsersWithRole.get(role);
      commit("gotGuestRelationUsers", guestRelationUsers);
    },
    async getOpeningHours({ commit, getters }) {
      const result = await apiGetOpeningHours.get(getters.activeVenue.venueId);
      if (result) {
        commit("gotOpeningHours", result);
      }
    },

    async getOpeningHoursForSpecificVenue({ commit, getters }, venueId) {
      const result = await apiGetOpeningHours.get(venueId);
      if (result) {
        commit("gotOpeningHoursForSpecificVenue", result);
      }
    },

    async getAddress({ commit, getters }) {
      const result = await apiGetAddress.get(getters.activeVenue.venueId);
      if (result) {
        commit("gotAddress", result);
      }
    },
    async getGeneralInfo({ commit, getters }) {
      const result = await apiGetGeneralInfo.get(getters.activeVenue.venueId);
      if (result) {
        commit("gotGeneralInfo", result);
      }
    },

    async updateOpeningHours({ commit, getters }, openingHours) {
      const result = await apiUpdateOpeningHours.post(
        getters.activeVenue.venueId,
        openingHours
      );

      return result;
    },

    async updateAddress({ commit, getters }, address) {
      const result = await apiUpdateAddress.post(
        getters.activeVenue.venueId,
        address
      );

      return result;
    },

    async updateGeneralInfo({ commit, getters }, generalInfo) {
      const result = await apiUpdateGeneralInfo.put(
        getters.activeVenue.venueId,
        generalInfo
      );



      return result;
    },

    async deleteVisit({ commit }, surveySessionId) {
      commit("isLoading", true);

      const result = await apiDeleteVisit.del(surveySessionId);

      commit("isLoading", false);

      return result;
    },
    async getUserVenues({ commit }) {
      commit("isLoading", true);

      const result = await apiGetUserVenues.get();
      console.log("VENUES", result);

      if (result) {
        commit("gotUserVenues", result);
      }

      commit("isLoading", false);
    },

    async ensureUserVenues({ commit, dispatch, getters }) {
      commit("isLoading", true);

      if (getters.venues.length === 0) {
        await dispatch("getUserVenues");
      }

      commit("isLoading", false);
    },

    async ensureAllVisits({ commit, dispatch, getters }) {
      commit("allLoading", true);

      const venues = getters.venues;
      const visits = getters.allVisits;
      const getList = [];
      for (let i = 0; i < venues.length; i++) {
        if (!visits[venues[i].venueId]) {
          getList.push(venues[i].venueId);
        }
      }
      const tasks = getList.map(e => dispatch("getVisits", e));
      await Promise.all(tasks);

      commit("loadedAllVisits", true);

      commit("allLoading", false);
    },

    async ensureAllReviews({ commit, dispatch, getters }) {
      commit("allLoading", true);

      const venues = getters.venues;
      const reviews = getters.allReviews;
      const getList = [];
      for (let i = 0; i < venues.length; i++) {
        if (!reviews[venues[i].venueId]) {
          getList.push(venues[i].venueId);
        }
      }
      const tasks = getList.map(e => dispatch("getMaintenanceReviews", e));
      await Promise.all(tasks);

      commit("loadedAllReviews", true);

      commit("allLoading", false);
    },

    async getVisits({ commit, dispatch, getters, rootState }, venueId) {
      commit("isLoading", true);

      const result = await apiGetVisits.get(venueId);

      for (let i = 0; i < result.length; i++) {
        if (!rootState.users.users[result[i].userId]) {
          await dispatch("users/getUser", result[i].userId, { root: true });
          //await dispatch("getUser", result[i].userId);
        }
      }

      const payload = {
        venueId,
        result
      };

      if (result) {
        commit("gotVisits", payload);
      }

      commit("isLoading", false);
    },
    async getMaintenanceReviews(
      { commit, dispatch, getters, rootState },
      venueId
    ) {
      commit("isLoading", true);

      const result = await apiGetMaintenanceReviews.get(venueId);

      for (let i = 0; i < result.length; i++) {
        if (!rootState.users.users[result[i].userId]) {
          await dispatch("users/getUser", result[i].userId, { root: true });
          //await dispatch("getUser", result[i].userId);
        }
      }

      const payload = {
        venueId,
        result
      };

      if (result) {
        commit("gotMaintenanceReviews", payload);
      }

      commit("isLoading", false);
    },
    async getVisitDetails({ commit }, surveySessionId) {
      commit("isLoading", true);

      console.log(`Getting visit details for`, surveySessionId);

      const result = await apiGetVisitDetails.get(surveySessionId);

      console.log("Details", result);

      const payload = {
        surveySessionId,
        result
      };

      if (result) {
        commit("gotVisitDetails", payload);
      }

      commit("isLoading", false);
    },

    async setActiveVenue({ commit, dispatch }, { venueId }) {
      commit("isLoading", true);

      localStorage.activeVenue = venueId;

      await dispatch("getUserVenues");

      commit("isLoading", false);
    }
  },
  getters: {
    venue: state => (id) => state.userVenues.find(v => v.venueId === id),
    venueLogo: state => (id) => state.userVenues.find(v => v.venueId === id).logoUrl,
    contactRolesMap: state => state.contactRolesMap,
    contactUsers: state => state.contactUsers,
    contactRoles: state => state.contactRoles,
    guestRelationUsers: state => state.guestRelationUsers,
    allVisits: state => {
      return state.visits;
    },
    allReviews: state => {
      return state.maintenanceReviews;
    },
    isAuthenticated: state => {
      return state.isAuthenticated;
    },
    visits: state => venueId => {
      return state.visits[venueId];
    },

    maintenanceReviews: state => venueId => {
      return state.maintenanceReviews[venueId];
    },

    visit: state => surveySessionId => {
      return state.visitDetails[surveySessionId];
    },

    openingHours: state => {
      return state.openingHours;
    },

    openingHoursForSpecificVenue: state => {
      return state.openingHoursForSpecificVenue;
    },

    address: state => {
      return state.address;
    },
    generalInfo: state => {
      return state.generalInfo;
    },
    venues: state => state.userVenues,
    loadedAllVisits: state => state.loadedAllVisits,
    loadedAllReviews: state => state.loadedAllReviews,
    activeVenue: state => {
      let activeVenue = state.userVenues.find(
        userVenue => userVenue.venueId === localStorage.activeVenue
      );

      if (!activeVenue) {
        if (state.userVenues.length === 0) {
          //localStorage.activeVenue = null;
          return null;
        }

        localStorage.activeVenue = state.userVenues[0].venueId;
        activeVenue = state.userVenues.find(
          userVenue => userVenue.venueId === localStorage.activeVenue
        );
      }

      return activeVenue;
    }
  }
};
